<script>
    import appConfig from "@/app.config";
    import { notificationMethods } from "@/state/helpers";
    import axios from "@/helpers/axios";
    import PaymentSidebar from "@/components/payment-sidebar";
    import Layout from "@/router/layouts/main";

    export default {
        components: { Layout, PaymentSidebar },
        name: "app",
        page: {
            // All subcomponent titles will be injected into this template.
            titleTemplate(title) {
                title = typeof title === "function" ? title(this.$store) : title;
                return title ? `${title} | ${appConfig.title}` : appConfig.title;
            }
        },
        watch: {
            $route() {
                this.clearNotification();
                this.loggedIn = !!localStorage.getItem("user");
            }
        },
        methods: {
            clearNotification: notificationMethods.clear
        },
        created() {
            this.loggedIn = !!localStorage.getItem("user");

            axios.interceptors.response.use(
                response => {
                    if (response.data.message) {
                        this.$toast.success(response.data.message);
                    }
                    return response.data;
                },
                error => {
                    if (error.response.status == 401) {
                        localStorage.removeItem("user");
                        localStorage.removeItem("selected-efp");
                        location.reload();
                        return;
                    } else if (error.response.status == 403) {
                        this.$router.replace({ name: "403" });
                        return;
                    } else {
                        this.$toast.error("Une erreur s'est produite veuillez réessayer plus tard!");
                    }
                    //return Promise.reject(error);
                }
            );
        }
    };
</script>

<template>
    <div id="app">
        <Layout v-if="loggedIn">
            <RouterView />
        </Layout>
        <RouterView v-else />
    </div>
</template>

<style lang="scss">
    .Vue-Toastification__toast {
        font-family: inherit !important;

        &-body {
            font-size: 14px;
        }
    }
</style>
